import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { useRessource } from './useRessource';
import { api } from '../lib/apiClient';
import type { SyntheseDemandes } from '../types';

/**
 * Le COMPTEUR DES DEMANDES D'INSCRIPTION du menu, partage — sur le
 * modele du compteur d'anomalies : recompte a chaque changement d'ecran
 * et sur demande, pour que la pastille ne mente pas apres un traitement.
 *
 * Il ne suit pas l'annee du bandeau : une demande vise l'annee ouverte
 * aux inscriptions, et le secretariat veut la voir quelle que soit
 * l'annee qu'il regarde.
 */
interface Demandes {
  nombre: number;
  rafraichir: () => void;
}

const Contexte = createContext<Demandes>({ nombre: 0, rafraichir: () => undefined });

export function FournisseurDemandes({ children }: { children: ReactNode }) {
  const { peut, entiteActive } = useAuth();
  const emplacement = useLocation();
  const autorise = peut('demande.lire');

  const { donnees, recharger } = useRessource(
    () =>
      autorise
        ? api.get<SyntheseDemandes>('/api/demandes/synthese')
        : Promise.resolve(null),
    [autorise, entiteActive?.id],
  );

  useEffect(() => {
    if (autorise) recharger();
    // `recharger` change a chaque rendu : le suivre relancerait en boucle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emplacement.pathname]);

  return (
    <Contexte.Provider value={{ nombre: donnees?.recues ?? 0, rafraichir: recharger }}>
      {children}
    </Contexte.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useDemandes(): Demandes {
  return useContext(Contexte);
}
